import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'
import { Paragraph } from 'components/patterns'
import { SelectMenu } from 'components/patterns/Inputs'
import { isNil } from 'ramda'

export const StyledParagraph = styled(Paragraph)`
  padding-top: 10px;
`

export const StyledUl = styled.ul`
  && {
    padding-left: 20px;
  }
`

export const StyledSelectMenu = styled(SelectMenu)`
  ${(props) =>
    stylesIf(
      isNil(props.value),
      `
    .ant-select-selection__placeholder {
      display: inline-block !important;
    }
  `
    )}

  .ant-select-selection__placeholder,
  .ant-select-selection__rendered {
    position: relative;
    top: 0;
    margin-top: 0;
    line-height: 30px;
  }

  .ant-select-selection__rendered {
    display: inline-block !important;
  }

  .ant-select-arrow {
    margin-left: 5px;
    margin-top: 0;
    position: relative;
    top: 0;
    right: 0;
    vertical-align: middle;
  }
`

export const Setting = styled.div`
  margin-bottom: 15px;
`

export const ModuleAndDescContainer = styled.div`
  margin-top: 5px;
  p {
    display: inline;
  }
`
